class TesterResultsReportController {
    constructor($http, $browser, $window, $location, $uibModal, $routeParams, toastr, moment, ngProgressFactory, UserDetailsApi, SettingsService, ReportServiceApi, ReportUtilityServiceApi, UserDetails, StateService, ReportUtils) {
        this.testerSelectionInProgress = false;
        // *** Arrow Methods ***
        this.init = () => {
            this.traceProgress = this.ngProgressFactory.createInstance();
            this.overlayNoRowsTemplate = "<span>Select a tester first</span>";
            this.hide = true;
            this.columnDefs = [
                {
                    headerName: 'UserId',
                    field: 'UserId',
                    width: 70,
                    minWidth: 85,
                    hide: this.hide
                },
                {
                    headerName: 'SimId',
                    field: 'SimId',
                    width: 70,
                    minWidth: 85,
                    filter: 'number',
                    hide: this.hide
                },
                {
                    headerName: 'IdPID',
                    field: 'IdPID',
                    width: 70,
                    minWidth: 85,
                    filter: 'number',
                    colId: 'IdPID',
                    hide: this.hide
                },
                {
                    headerName: 'Simulator',
                    field: 'SimName',
                    width: 120,
                    minWidth: 130,
                    cellRenderer: this.simCellRenderer,
                    sort: 'asc'
                },
                {
                    headerName: 'SuiteId',
                    field: 'TestSuiteId',
                    width: 70,
                    minWidth: 110,
                    filter: 'number',
                    hide: this.hide
                },
                {
                    headerName: 'Test Suite',
                    field: 'TestSuiteName',
                    width: 120,
                    minWidth: 250,
                    cellRenderer: this.suiteCellRenderer
                },
                {
                    headerName: 'Test Case',
                    field: 'TestCaseName',
                    width: 120,
                    minWidth: 130,
                    cellRenderer: this.caseCellRenderer
                },
                {
                    headerName: 'Tester Reference',
                    field: 'IdPEmail',
                    width: 200,
                    minWidth: 155,
                    filter: 'number',
                    colId: 'IdPEmail',
                    hide: this.hide
                },
                {
                    headerName: 'Host',
                    field: 'HostVerdict',
                    colId: 'HostVerdict',
                    width: 100,
                    minWidth: 95,
                    hide: false
                },
                {
                    headerName: 'Clearing',
                    field: 'ClearingVerdict',
                    width: 100,
                    minWidth: 110,
                    cellRenderer: this.clearingVerdictRenderer
                },
                {
                    headerName: 'Terminal',
                    field: 'TerminalVerdict',
                    colId: 'TerminalVerdict',
                    width: 100,
                    minWidth: 120,
                    hide: false
                },
                {
                    headerName: 'Verdict',
                    field: 'FinalVerdict',
                    width: 100,
                    minWidth: 110,
                    cellRenderer: this.finalVerdictRenderer
                },
                {
                    headerName: 'Message',
                    field: 'Message',
                    colId: 'Message',
                    width: 120,
                    minWidth: 130,
                    hide: false
                },
                {
                    headerName: 'Timestamp (UTC)',
                    field: 'Timestamp',
                    width: 155,
                    minWidth: 180,
                    cellRenderer: this.timeCellRenderer
                },
                // Trace XML Message Fields
                {
                    headerName: 'Trans Amount (04)',
                    field: 'TransAmount',
                    colId: 'TransAmount',
                    width: 120,
                    minWidth: 140,
                    hide: false
                },
                {
                    headerName: 'Audit Num (11)',
                    field: 'AuditNum',
                    colId: 'AuditNum',
                    width: 120,
                    minWidth: 140,
                    hide: false
                },
                {
                    headerName: 'Retrieval Reference Num (37)',
                    field: 'RetrievalReferenceNum',
                    colId: 'RetrievalReferenceNum',
                    width: 120,
                    minWidth: 140,
                    hide: false
                },
                {
                    headerName: 'AuthId Response (38)',
                    field: 'AuthIdResponse',
                    colId: 'AuthIdResponse',
                    width: 120,
                    minWidth: 140,
                    hide: false
                },
                {
                    headerName: 'Response Code (39)',
                    field: 'ResponseCode',
                    colId: 'ResponseCode',
                    width: 120,
                    minWidth: 140,
                    hide: false
                },
                {
                    headerName: 'TerminalId (41)',
                    field: 'TerminalId',
                    width: 120,
                    minWidth: 140,
                    colId: 'TerminalId_41',
                    hide: false
                },
                {
                    headerName: 'MerchantId (42)',
                    field: 'MerchantId',
                    width: 120,
                    minWidth: 140,
                    colId: 'MerchantId_42',
                    hide: false
                },
                // DE55_ fields
                {
                    headerName: 'TVR (55.95)',
                    field: 'Tvr5595',
                    colId: 'Tvr5595',
                    width: 120,
                    minWidth: 140,
                    hide: false
                },
                {
                    headerName: 'Transaction Amount (55.9F02)',
                    field: 'DE55_TransactionAmount',
                    colId: 'DE55_TransactionAmount',
                    width: 120,
                    minWidth: 140,
                    hide: false
                },
                {
                    headerName: 'Terminal Capabilites (55.9F33)',
                    field: 'DE55_TerminalCapabilites',
                    colId: 'DE55_TerminalCapabilites',
                    width: 120,
                    minWidth: 140,
                    hide: false
                },
                {
                    headerName: 'CVM Results (55.9F34)',
                    field: 'DE55_CVMResults',
                    colId: 'DE55_CVMResults',
                    width: 120,
                    minWidth: 140,
                    hide: false
                },
                {
                    headerName: 'Unpredictable Num (55.9F37)',
                    field: 'DE55_UnpredictableNum',
                    colId: 'DE55_UnpredictableNum',
                    width: 120,
                    minWidth: 140,
                    hide: false
                },
                {
                    headerName: 'DE55_71 (55.71)',
                    field: 'DE55_71',
                    colId: 'DE55_71',
                    width: 120,
                    minWidth: 140,
                    hide: false
                },
                {
                    headerName: 'DE55_72 (55.72)',
                    field: 'DE55_72',
                    colId: 'DE55_72',
                    width: 120,
                    minWidth: 140,
                    hide: false
                },
                {
                    headerName: 'DE55_AID (55.84)',
                    field: 'DE55_AID',
                    colId: 'DE55_AID',
                    width: 120,
                    minWidth: 140,
                    hide: false
                },
                {
                    headerName: 'DE55_91 (55.91)',
                    field: 'DE55_91',
                    colId: 'DE55_91',
                    width: 120,
                    minWidth: 140,
                    hide: false
                },
                {
                    headerName: 'Reasons',
                    field: 'Reasons',
                    colId: 'Reasons',
                    width: 440,
                    minWidth: 160,
                    hide: false
                }
            ];
            this.gridOptions = this.ReportUtils.getDefaultGridOptions(this);
            this.gridOptions.isExternalFilterPresent = this.isExternalFilterPresent;
            this.gridOptions.doesExternalFilterPass = this.doesExternalFilterPass;
            this.rowCount = '0';
            this.state = {
                projectIterationId: undefined,
                showTesters: true,
                showSpinner: true,
                linkFromName: true,
                userDetails: undefined,
                reportRequest: {
                    UserId: 0,
                    SimId: 0,
                    TestSuiteId: 0
                },
                gridOptions: {},
                DateFormats: {},
                activeTesters: [],
                selectedTester: { Id: 0, Name: 'Unknown' },
                selectedSim: { Id: 0, Name: 'Unknown' },
                selectedSuite: { Id: 0, Name: 'Unknown' },
                selectedTest: undefined,
                hideNav: _.startsWith(this.location.path(), '/Reports'),
                isSSO: false,
                userPlaceholder: 'Select a tester',
                userResultsPopoverText: 'Testers with test results',
                simResultsPopoverText: 'Tester simulators with test results',
                testSuitesPopoverText: 'Tester suites with test results'
            };
            this.data = {
                sims: [],
                suites: [],
                testerSimSuites: [],
                connectedUser: undefined,
                testResults: []
            };
            // @ts-ignore: Report clashes with dom.lib.d.ts Report
            this.testerCertReport = {
                Id: 0,
                Name: '',
                Description: 'Tester Cert Report',
                Route: '',
                Component: '',
                Icon: '',
                IsDeleted: false,
                LastAmended: null,
                LastAmendedBy: 0,
                ReportOrder: 0,
                IsExternal: false,
                Filetype: '',
                IdPId: ''
            };
            this.SettingsService.getSettings().then((response) => {
                let appSettings = response.data;
                this.state.DateFormats = {
                    DateTimeFormat: appSettings.DateTimeFormat,
                    DateFormat: appSettings.DateFormat,
                    TimeFormat: appSettings.TimeFormat
                };
                this.state.isSSO = appSettings.UseSingleSignOn;
                this.UserDetailsApi.get().then((response) => {
                    this.data.connectedUser = response.data;
                    this.UserDetails.get().then((data) => {
                        this.state.userDetails = data; // setup our user details
                        if (this.state.userDetails.IsProjectTester) {
                            this.state.userPlaceholder = 'Select a project',
                                this.state.userResultsPopoverText = 'Project with test results',
                                this.state.simResultsPopoverText = 'Project simulators with test results',
                                this.state.testSuitesPopoverText = 'Project suites with test results';
                        }
                        // Tester sees his own report
                        if (this.state.userDetails.IsTester ||
                            this.state.userDetails.IsManagedTester ||
                            this.state.userDetails.IsGroupTester) {
                            this.state.selectedTester = {
                                Id: this.state.userDetails.Id,
                                Name: this.state.userDetails.UserName
                            };
                            this.getTesterCertReport(this.state.selectedTester);
                            this.state.showTesters = false;
                            return;
                        }
                        // Support/Admin sees all tester reports. TeamSupport is filtered to his team members
                        let isSupporting = this.state.userDetails.IsSupport ||
                            this.state.userDetails.IsProjectTester ||
                            this.state.userDetails.IsAdmin;
                        if (isSupporting) {
                            this.ReportServiceApi.getActiveTesters().then((response) => {
                                this.state.activeTesters = response.data;
                                if (this.state.activeTesters[0] === null) {
                                    this.state.activeTesters[0] = {
                                        Id: 0,
                                        Name: 'No testers available'
                                    };
                                }
                                this.state.selectedTester = null;
                                this.state.showTesters = true;
                                this.state.showSpinner = false;
                                return;
                            });
                        }
                    }, () => {
                        this.toastr.error('Please make sure that you are logged in to OTS UTP!');
                        this.window.location.href = this.browser.baseHref() + 'account/login';
                        return;
                    });
                    this.ReportServiceApi.getReportByName('TesterCertReport').then((response) => {
                        if (Object.keys(response.data).length > 0) {
                            this.testerCertReport = response.data;
                        }
                        else {
                            this.toastr.warning('Report descriptions not found');
                        }
                    });
                });
            });
        };
        this.onSizeChange = () => {
            this.gridOptions.api.sizeColumnsToFit();
        };
        this.timeCellRenderer = (params) => {
            let time = [
                '<span>',
                this.moment(new Date(params.data.Timestamp))
                    .format(this.state.DateFormats.DateTimeFormat),
                '</span>'
            ].join('');
            return time;
        };
        this.finalVerdictRenderer = (row) => {
            let classToAdd = 'text-success';
            if (row.data.FinalVerdict === 'Fail') {
                classToAdd = 'text-danger';
            }
            if (row.data.FinalVerdict === 'Suspended') {
                classToAdd = 'text-muted';
            }
            let finalVerdict = [
                '<span',
                'class="',
                classToAdd,
                '">',
                row.data.FinalVerdict,
                '</span>'
            ].join(' ');
            return finalVerdict;
        };
        this.clearingVerdictRenderer = (row) => {
            let classToAdd = 'text-success';
            if (row.data.ClearingVerdict === 'Fail') {
                classToAdd = 'text-danger';
            }
            let clearingVerdict = [
                '<span',
                'class="',
                classToAdd,
                '">',
                row.data.ClearingVerdict,
                '</span>'
            ].join(' ');
            return clearingVerdict;
        };
        this.createLink = (data, tooltip, action) => {
            let link = [
                '<span',
                'ng-if="!vm.state.linkFromName">',
                data,
                '</span><a ng-href=""',
                'class="space-top pointer"',
                'title="',
                tooltip,
                '"',
                'ng-if="vm.state.linkFromName"',
                'ng-click="',
                action,
                '">',
                data,
                '</a>'
            ].join(' ');
            return link;
        };
        this.simCellRenderer = (row) => {
            let tooltip = `View Trace Summary page for ${row.data.SimName}`;
            let action = 'vm.simTraceSummary(data)';
            // Do not show trace summary links for managed Tester
            if (this.state.userDetails.IsManagedTester || this.state.isSSO) {
                return this.genericCellRenderer(row.data.SimName);
            }
            else {
                return this.createLink(row.data.SimName, tooltip, action);
            }
        };
        this.suiteCellRenderer = (row) => {
            let tooltip = `View Trace Summary page for ${row.data.TestSuiteName}`;
            let action = 'vm.suiteTraceSummary(data)';
            // Do not show trace summary links for managed Tester
            if (this.state.userDetails.IsManagedTester || this.state.isSSO) {
                return this.genericCellRenderer(row.data.TestSuiteName);
            }
            else {
                return this.createLink(row.data.TestSuiteName, tooltip, action);
            }
        };
        this.caseCellRenderer = (row) => {
            let tooltip = `View Trace Details for ${row.data.TestCaseName}`;
            let action = 'vm.caseTraceDetails(data)';
            if (this.state.isSSO) {
                return this.genericCellRenderer(row.data.TruncatedTestCaseName, row.data.TestCaseName);
            }
            else {
                return this.createLink(row.data.TruncatedTestCaseName, tooltip, action);
            }
        };
        this.genericCellRenderer = (columnValue, tooltip = '') => {
            return '<span title="' + tooltip + '">' + columnValue + '</span>';
        };
        this.buildTraceSummaryPath = (testerId, simId, suiteId) => {
            return suiteId
                ? [
                    'TraceSummarySource/TesterCertReport/',
                    testerId,
                    '/',
                    simId,
                    '/',
                    suiteId
                ].join('')
                : [
                    'TraceSummarySource/TesterCertReport/',
                    testerId,
                    '/',
                    simId
                ].join('');
        };
        this.openDetails = (selectedItems, mode) => {
            let tdParams = {
                selectedItems: selectedItems,
                mode: mode,
                user: this.data.connectedUser,
                overTheShoulder: false
            };
            let modalInstance = this.uibModal.open({
                animation: true,
                size: 'xl',
                backdrop: 'static',
                keyboard: false,
                component: 'traceDetailsModal',
                resolve: {
                    params: () => {
                        return tdParams;
                    }
                }
            });
            modalInstance.closed.then(() => {
                // Don't need to update/refresh anything
            });
        };
        this.autoSizeAll = () => {
            let allColumnIds = [];
            if (this.columnDefs === undefined || this.columnDefs === null) {
                this.columnDefs = this.gridOptions.columnDefs;
            }
            this.columnDefs.forEach((columnDef) => {
                allColumnIds.push(columnDef.field);
            });
            this.gridOptions.columnApi.autoSizeColumns(allColumnIds);
        };
        this.onModelUpdated = () => {
            let model = this.gridOptions.api.getModel();
            let processedRows = model.getRowCount();
            this.rowCount = processedRows.toLocaleString();
            this.autoSizeAll();
        };
        this.isExternalFilterPresent = () => {
            var _a, _b;
            // if ageType is not everyone, then we are filtering    <----??? This looks like the sample comment from the ag-grid site
            return ((_a = this.state.selectedSim) === null || _a === void 0 ? void 0 : _a.Id) > 0 || ((_b = this.state.selectedSuite) === null || _b === void 0 ? void 0 : _b.Id) > 0;
        };
        this.doesExternalFilterPass = (node) => {
            const noSimFilter = !this.state.selectedSim || this.state.selectedSim.Id === 0;
            const noTestSuiteFilter = !this.state.selectedSuite || this.state.selectedSuite.Id === 0;
            // No filter
            if (noSimFilter && noTestSuiteFilter) {
                return false;
            }
            // Sim only filter
            if (noTestSuiteFilter) {
                return node.data.SimId === this.state.selectedSim.Id;
            }
            // Sim and Suite filter
            return (node.data.SimId === this.state.selectedSim.Id &&
                node.data.TestSuiteId === this.state.selectedSuite.Id);
        };
        this.selectTester = (tester) => {
            if (this.state.activeTesters === undefined || this.state.activeTesters[0] === null) {
                // something is wrong with the data, we cant select back out.
                return;
            }
            if (tester === null) {
                // clear button was clicked by user
                // => we need to ensure that no simulator or test suite filters are set
                this.state.selectedTester = null;
                this.data.testResults = [];
                this.gridOptions.api.setRowData(this.data.testResults);
                this.selectSim(null);
            }
            else {
                this.state.selectedTester = tester;
                this.getTesterCertReport(this.state.selectedTester);
                // NOTE: We will select the first sim and suite
            }
        };
        this.selectSim = (sim) => {
            if (sim === null) {
                this.state.selectedSim = null;
                this.selectSuite(null);
            }
            else {
                if (angular.isUndefined(sim)) {
                    sim = { Id: 0, Name: 'All Simulators' };
                    this.state.selectedSim = sim;
                }
                this.data.suites = this.ReportService.simSuites(this.data.testerSimSuites, sim.Id);
                this.state.selectedSuite = this.data.suites[0];
            }
            this.gridOptions.api.onFilterChanged();
        };
        this.selectSuite = (suite) => {
            if (suite === null) {
                this.state.selectedSuite = null;
            }
            else {
                if (angular.isUndefined(suite)) {
                    suite = { Id: 0, Name: 'All Suites' };
                }
                this.state.selectedSuite = suite;
            }
            this.gridOptions.api.onFilterChanged();
        };
        this.getTesterCertReport = (tester) => {
            // We get all of the data and then filter it on the client side
            this.traceProgress.start();
            let req = {
                UserId: tester.Id,
                SimId: 0,
                TestSuiteId: 0
            };
            this.gridOptions.api.showLoadingOverlay();
            this.testerSelectionInProgress = true;
            this.state.reportRequest = req;
            this.ReportServiceApi.getTesterCertReport(req).then((response) => {
                this.state.showSpinner = false;
                this.traceProgress.complete();
                this.testerSelectionInProgress = false;
                let data = response.data;
                if (this.state.selectedTester.Id > 0) {
                    this.gridOptions.api.setRowData(data.TestResults);
                    this.gridOptions.columnApi.setColumnVisible('IdPEmail', this.state.userDetails.IsSupport && this.state.isSSO);
                }
                // Put the data in the view model so that we can inspect it
                this.data.testResults = data.TestResults;
                try {
                    this.autoSizeAll();
                }
                catch (err) { }
                this.rowData = data;
                this.data.testerSimSuites = data.TesterSimSuites;
                this.data.sims = this.ReportService.sims(this.data.testerSimSuites);
                this.state.selectedSim = this.data.sims[0];
                this.syncGridColumnVisibility();
                this.data.suites = this.ReportService.simSuites(this.data.testerSimSuites, this.state.selectedSim.Id);
                this.state.selectedSuite = this.data.suites[0];
                this.state.projectIterationId = this.data.testResults[0].ProjectIterationId !== null ? this.data.testResults[0].ProjectIterationId : 0;
                this.gridOptions.api.onFilterChanged();
                this.gridOptions.api.hideOverlay();
            }, () => {
                this.gridOptions.api.hideOverlay();
                this.testerSelectionInProgress = false;
                this.traceProgress.complete();
            });
        };
        this.setColumnVisibility = (visibility) => {
            this.gridOptions.columnApi.setColumnVisible('TransAmount', visibility);
            this.gridOptions.columnApi.setColumnVisible('AuditNum', visibility);
            this.gridOptions.columnApi.setColumnVisible('RetrievalReferenceNum', visibility);
            this.gridOptions.columnApi.setColumnVisible('AuthIdResponse', visibility);
            this.gridOptions.columnApi.setColumnVisible('ResponseCode', visibility);
            this.gridOptions.columnApi.setColumnVisible('MerchantId_42', visibility);
            this.gridOptions.columnApi.setColumnVisible('TerminalId_41', visibility);
            this.gridOptions.columnApi.setColumnVisible('Tvr5595', visibility);
            this.gridOptions.columnApi.setColumnVisible('DE55_TransactionAmount', visibility);
            this.gridOptions.columnApi.setColumnVisible('DE55_TerminalCapabilites', visibility);
            this.gridOptions.columnApi.setColumnVisible('DE55_CVMResults', visibility);
            this.gridOptions.columnApi.setColumnVisible('DE55_UnpredictableNum', visibility);
            this.gridOptions.columnApi.setColumnVisible('DE55_71', visibility);
            this.gridOptions.columnApi.setColumnVisible('DE55_72', visibility);
            this.gridOptions.columnApi.setColumnVisible('DE55_AID', visibility);
            this.gridOptions.columnApi.setColumnVisible('DE55_91', visibility);
            this.gridOptions.columnApi.setColumnVisible('Reasons', visibility);
            this.gridOptions.columnApi.setColumnVisible('Message', visibility);
            this.gridOptions.columnApi.setColumnVisible('TerminalVerdict', visibility);
            this.gridOptions.columnApi.setColumnVisible('HostVerdict', visibility);
        };
        this.setClearingColumnVisibility = (clearingsimid) => {
            if (clearingsimid > 0) {
                this.gridOptions.columnApi.setColumnVisible('ClearingVerdict', true);
            }
            else {
                this.gridOptions.columnApi.setColumnVisible('ClearingVerdict', false);
            }
        };
        this.syncGridColumnVisibility = () => {
            this.setColumnVisibility(false);
            /* sync ISO8583 column visibility */
            // this.gridOptions.columnApi.setColumnVisible('TerminalId_41', false);
            // this.gridOptions.columnApi.setColumnVisible('MerchantId_42', false);
            if (this.state.selectedSim.Id === 0) {
                /* Check all sims as selection is All Simulators */
                this.data.testerSimSuites.forEach((x) => {
                    if (x.MessageProtocol === 'ISO8583') {
                        this.setColumnVisibility(true);
                        // this.gridOptions.columnApi.setColumnVisible('TerminalId_41', true);
                        // this.gridOptions.columnApi.setColumnVisible('MerchantId_42', true);
                    }
                    this.setClearingColumnVisibility(x.ClearingSimId);
                });
            }
            else {
                /* Check for selected Simulator */
                this.data.testerSimSuites.forEach((x) => {
                    if (x.SimId === this.state.selectedSim.Id && x.MessageProtocol === 'ISO8583') {
                        this.setColumnVisibility(true);
                        // this.gridOptions.columnApi.setColumnVisible('TerminalId_41', true);
                        // this.gridOptions.columnApi.setColumnVisible('MerchantId_42', true);
                    }
                    this.setClearingColumnVisibility(x.ClearingSimId);
                });
            }
            this.gridOptions.api.setRowData(this.data.testResults);
        };
        this.getTesterCertArchive = (tester) => {
            this.traceProgress.start();
            let userId;
            if (this.state.userDetails.IsTester ||
                this.state.userDetails.IsManagedTester) {
                userId = this.state.userDetails.Id;
            }
            else {
                userId = tester.Id;
            }
            let simId = this.state.selectedSim.Id;
            let suiteId = this.state.selectedSuite.Id;
            // The api call does not return so we complete progess synchronously
            this.traceProgress.complete();
            this.state.showSpinner = true;
            let baseHref = this.browser.baseHref();
            let url = [
                baseHref, 'api/TesterCertArchive/ArchiveZip?UserId=', userId,
                '&simId=', simId, '&suiteId=', suiteId
            ].join('');
            this.http.get(url, { responseType: 'arraybuffer' })
                .then(response => {
                this.state.showSpinner = false;
                let filename = 'TerterCertArchive.zip';
                const contentDisposition = response.headers('Content-Disposition');
                if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(contentDisposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '');
                    }
                }
                const blob = new Blob([response.data], { type: 'application/zip' });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                link.click();
            })
                .catch(error => {
                this.state.showSpinner = false;
                this.toastr.error('Error downloading the Tester Cert Archive');
            });
        };
        this.exportCsv = () => {
            this.traceProgress.start();
            this.traceProgress.complete();
            let user = this.state.userDetails.Description;
            let title = [user, ' ', this.testerCertReport.Description + '.csv'].join('');
            let reportName = this.ReportService.addDateToTitle(title);
            let date = this.moment(new Date()).format(this.state.DateFormats.DateFormat);
            let time = this.moment(new Date()).format(this.state.DateFormats.TimeFormat);
            // let published = [' created on ' + date, ' at ', time].join('');
            let published = '';
            let customHeader = [
                `${this.testerCertReport.Description} Report for ${this.state.userDetails.IsProjectTester ? 'project' : 'tester'}: `,
                this.state.selectedTester.Name,
                published,
                '\n\n'
            ].join('');
            let params = {
                allColumns: false,
                fileName: reportName,
                customHeader: customHeader
            };
            this.gridOptions.api.exportDataAsCsv(params);
        };
        this.$onInit = () => {
            this.init();
        };
        this.simTraceSummary = (row) => {
            let loggedInUserId = this.state.userDetails.Id;
            let testerId = row.UserId || loggedInUserId;
            if (this.state.selectedSim === null) {
                return;
            }
            let url = this.buildTraceSummaryPath(testerId, row.SimId, null);
            this.StateService.reset();
            this.StateService.selectedTester = {
                Id: row.UserId,
                Name: row.UserDescription
            };
            this.StateService.selectedSim = { Id: row.SimId, Name: row.SimName };
            this.location.path(url);
        };
        this.suiteTraceSummary = (row) => {
            let loggedInUserId = this.state.userDetails.Id;
            let testerId = row.UserId || loggedInUserId;
            let url = this.buildTraceSummaryPath(testerId, row.SimId, row.TestSuiteId);
            this.StateService.reset();
            this.StateService.selectedTester = {
                Id: row.UserId,
                Name: row.UserDescription
            };
            this.StateService.selectedSim = { Id: row.SimId, Name: row.SimName };
            this.StateService.selectedSuite = {
                Id: row.TestSuiteId,
                Name: row.TestSuiteName
            };
            this.location.path(url);
        };
        this.caseTraceDetails = (row) => {
            let mode = { view: false, run: false };
            let selectedItems = {
                selectedTester: this.state.selectedTester,
                selectedSim: { Id: row.SimId, Name: row.SimName },
                selectedSuite: { Id: row.TestSuiteId, Name: row.TestSuiteName },
                selectedTest: { Id: row.TestId, Name: row.TestCaseName },
                projectIterationId: this.state.projectIterationId,
                unknownUser: { Id: 0, Name: 'Unknown' },
                fromTester: false
            };
            this.openDetails(selectedItems, mode);
        };
        this.ReportServiceApi = ReportServiceApi;
        this.ReportService = ReportUtilityServiceApi;
        this.uibModal = $uibModal;
        this.location = $location;
        this.moment = moment;
        this.routeParams = $routeParams;
        this.SettingsService = SettingsService;
        this.StateService = StateService;
        this.UserDetailsApi = UserDetailsApi;
        this.UserDetails = UserDetails;
        this.toastr = toastr;
        this.browser = $browser;
        this.window = $window;
        this.ReportUtils = ReportUtils;
        this.ngProgressFactory = ngProgressFactory;
        this.http = $http;
    }
}
// Component Declaration
angular.module('app').component('testerResultsReport', {
    templateUrl: 'Scripts/App/partials/Reports/Tester-Results-Report.tpl.html',
    bindings: {
        testerId: '<'
    },
    controllerAs: 'vm',
    controller: TesterResultsReportController
});
